export default defineNuxtRouteMiddleware((to, from) => {
    // Redirect all routes except root (/) to root
    if (to.fullPath !== '/') {
        return navigateTo('/', {
            external: false
        })
    }
})
